import { render, staticRenderFns } from "./CareerEventCard.vue?vue&type=template&id=1c0d3dce&scoped=true"
import script from "./CareerEventCard.vue?vue&type=script&lang=js"
export * from "./CareerEventCard.vue?vue&type=script&lang=js"
import style0 from "./CareerEventCard.vue?vue&type=style&index=0&id=1c0d3dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d3dce",
  null
  
)

export default component.exports